import { Form, Input } from "antd";
import { observer } from "mobx-react";

import type DocumentFolder from "stores/DocumentFolder";
import { DocumentType } from "types/DocumentType";
import { normalizeInputSpace } from "utils/String";

import { ModalForm, type SubmitCallback } from "../ModalForm";

export interface AddClientModalProps {
  isVisible?: boolean;
  onClose?: () => void;
  parentDocument: DocumentFolder;
}

function AddClientModal({
  isVisible,
  onClose,
  parentDocument,
}: AddClientModalProps) {
  const handleFormSubmit: SubmitCallback = async (values) => {
    await parentDocument.documents.add({
      name: String(values.clientName).trimEnd(),
      type: DocumentType.CLIENT,
    });
  };

  return (
    <ModalForm
      formName="AddClientModalForm"
      okText="Add"
      onClose={onClose}
      onSubmit={handleFormSubmit}
      open={isVisible}
      title="Add Client"
    >
      <Form.Item
        label="Client name"
        name="clientName"
        normalize={(v) => normalizeInputSpace(v)}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </ModalForm>
  );
}

export default observer(AddClientModal);
